<mat-table
  matTableExporter
  [dataSource]="dataSourceMatTable"
  matSort
  #exporter="matTableExporter"
  [hiddenColumns]="[0]"
>
  <ng-container
    *ngFor="let column of columns"
    [matColumnDef]="column.columnDef"
  >
    <ng-container
      *ngIf="column.orderBy || column.orderBy == undefined; else noSort"
    >
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ column.header }}
      </mat-header-cell>
    </ng-container>
    <ng-template #noSort>
      <mat-header-cell *matHeaderCellDef class="mat-sort-header-content">
        {{ column.header }}
      </mat-header-cell>
    </ng-template>
    <mat-cell *matCellDef="let element">
      <ng-container
        *ngIf="column.actions?.length; else defaultTemplate"
      >
        <ng-container *ngIf="column.actions.length > 1; else noSubMenuAction">
          <button class="icon-button" [matMenuTriggerFor]="menu" aria-label="">
            <img class="icon" src="./assets/img/ico-options.png" />
          </button>
          <mat-menu #menu="matMenu" [class]="column.cssClass">
            <button
              mat-menu-item
              *ngFor="let action of column.actions"
              [class]="action.cssClass"
              (click)="handleAction(action, element)"
            >
              {{ action.titulo }}
            </button>
          </mat-menu>
        </ng-container>
        <ng-template #noSubMenuAction>
          <button
            mat-menu-item
            *ngFor="let action of column.actions"
            [class]="action.cssClass"
            (click)="handleAction(action, element)"
          >
            {{ action.titulo }}
          </button>
        </ng-template>
      </ng-container>

      <ng-template #defaultTemplate>
        <ng-container *ngIf="column.multiValor">
          <app-extended-mat-table-multi-valor
            [parent]="this"
            [campos]="column.campos"
            [separador]="column.separador"
            [elemento]="element"
          ></app-extended-mat-table-multi-valor>
        </ng-container>
        <ng-container *ngIf="!column.multiValor">
            <span
              class="row-span"
              [matTooltip]="format(element[column.columnDef], column.format)"
            >
              {{ format(element[column.columnDef], column.format) }}
            </span>
          </ng-container>
          
      </ng-template>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row
    *matRowDef="let row; columns: displayedColumns"
    [ngClass]="getRowClass(row, validaCorLinha.condition)"
  ></mat-row>
</mat-table>`

<ng-container *ngIf="showPaginator">
  <mat-paginator
    #paginator
    class="filter-paginator"
    [pageSizeOptions]="[10, 20, 50, 100, 500, 1000, 9999]"
    [pageSize]="10"
    aria-label="Seleciona a página"
    showFirstLastButtons
    
  >
  </mat-paginator>
</ng-container>